<template>

  <v-dialog v-model="value" persistent max-width="400">
    <v-card>

      <v-card-title>
        <slot name="title"></slot>
      </v-card-title>

      <v-card-text>
        <slot name="text">Are you sure?</slot>
      </v-card-text>

      <v-divider class="mt-4" />

      <v-card-actions>
        <v-spacer></v-spacer>

        <v-btn color="primary" small @click="confirm()" :loading="loading" :disabled="loading">{{ submitText }}</v-btn>
        <v-btn color="primary" small outlined @click="close()" :disabled="loading">{{ cancelText }}</v-btn>

      </v-card-actions>

    </v-card>
  </v-dialog>

</template>

<script>
  export default {

    props: {

      value: {
        type: Boolean,
        default: false
      },

      loading: {
        type: Boolean,
        default: false
      },

      submitText: {
        type: String,
        default: 'OK'
      },

      cancelText: {
        type: String,
        default: 'Cancel'
      }

    },

    methods: {
      
      confirm() {
        this.$emit('confirmed');
      },

      close() {
        this.$emit('close');
      },

    },

  }
</script>

<style lang="scss" scoped>

</style>
